import { useMotionValue } from 'motion/react';
import { useEffect } from 'react';
export const useScrollYMotionValue = () => {
    const scrollY = useMotionValue(0);
    useEffect(() => {
        const controller = new AbortController();
        const updateScrollY = () => scrollY.set(window.scrollY);
        window.addEventListener('scroll', updateScrollY, { passive: true, signal: controller.signal });
        updateScrollY();
        return () => controller.abort();
    }, [scrollY]);
    return scrollY;
};
